// Version de l'application — format vX.Y.ZZ
export const APP_VERSION = 'v0.1.02-a';
